import React, { useEffect, useState } from 'react';
import './VideoItem.css';
import { extractYouTubeVideoId } from '../util/util';

const VideoItem = ({ video, onSelectVideo, selectedVideo }) => {
  const videoId = extractYouTubeVideoId(video.youtube_url);
  const [selected, setSelected] = useState(false);

  useEffect(() => {
    setSelected(selectedVideo);
  }, [selectedVideo]);

  const thumbnail_url = `https://i.ytimg.com/vi/${videoId}/default.jpg`; //video.snippet.thumbnails.medium.url;
  return (
    <div className={`video-item item ${selected === video ? 'selected' : ''}`} onClick={() => onSelectVideo(video)}>
      <img className="ui image" alt='thumbnails' src={thumbnail_url} data-video_id={videoId} />
      <div className="content">
        <div className="header">
          <div>{video.title}</div>
        </div>
      </div>
    </div>
  );
}

export default VideoItem;
